export const PlanEnum = Object.freeze({

	THERA_LOGIC_EARLY_ADOPTER: "910883",

	IFS_MAPPING_TRIAL_7D: "909938",

	GENOGRAM_CLASS_YEARLY: "897643",
	GENOGRAM_YEARLY: "897164",
	GENOGRAM_MONTHLY: "895944",
	GENOGRAM_MONTHLY_TRIAL: "793798",
	GENOGRAM_LIFETIME: "854620",
	PERSONAL_TOUCH_YEARLY: "888193",
	PERSONAL_TOUCH_MONTHLY: "850090",
	ULTIMATE_YEARLY: "888194",
	ULTIMATE_YEARLY_DISCOUNT: "883211",
	PERSONAL_TOUCH_TRIAL: "762957",
	WHEEL_OF_LIFE_TRIAL: "898277",
	QWOACH_YEARLY: "756749",
	QWOACH_MAIN: "762957",
	CORE_CONTRIBUTOR: "569425",
	ESSENTIALS: "752045",
	INFOSTACK_SPECIAL: "601237",
	CONTRIBUTOR_SPECIAL: "601238"
});
